import { getCampaignStatuses, getFilterOptions, getMdCampaigns } from '../../../api';
import { onRequest } from '../..';
import { ActionsType, PropertyType, formatToISO } from '../../../common';
import { validateForm } from '../../../view/pages/MoneyDrop/MoneyDrop.helper';
import { CampaignFormKey } from '../../../view/pages/MoneyDrop/MoneyDrop.const';
import { getCasinoGames } from '../../../api/endpoints/getCasinoGames';
import { addMoneyDrop } from '../../../api/endpoints/addMoneyDrop';
import { getAverageRates } from '../../../api/endpoints/getAverageRates';

const campaignsInit = async (payload: PropertyType) => {
	const { token, page } = payload;
	const data = await getMdCampaigns({ token, page, query: '' });
	return { ...data, currentPage: page, campainsLoading: false };
};

const partnersInit = (user: PropertyType) => {
	const { partners } = user;

	return { partners };
};

const gamesInit = async (payload: PropertyType) => {
	const { token } = payload;
	const { games } = await getCasinoGames({ token, query: '', perPage: 10000 });

	const allCurrencies = await getAverageRates(payload);

	const currencies = allCurrencies.map((c: any) => ({
		label: c.name,
		value: c.id,
	}));

	return { games, currencies };
};

const statusesInit = async (payload: PropertyType) => {
	const { token } = payload;
	const data = await getCampaignStatuses({ token });

	return { ...data };
};

const getFiltersUrl = (filters: PropertyType[]) => {
	const urlFragments: string[] = [];

	filters.forEach((f) => {
		const value = f.name == 'start_date' || f.name == 'end_date' ? formatToISO(f.value) : f.value;
		urlFragments.push(`${f.name}=${value}`);
	});

	return `?${urlFragments.join('&')}`;
};

const filterData = async (token: string, page: string, filters: PropertyType[]) => {
	const query = filters.length ? getFiltersUrl(filters) : '';
	const data = await getMdCampaigns({ token, page, query });

	return {
		...data,
		filters,
		filtering: filters.length > 1,
		currentPage: page,
		campainsLoading: false,
	};
};

const onFilter = async (state: PropertyType, payload: PropertyType) => {
	const { token, page, filters } = payload;

	return filterData(token, page, filters);
};

const onPageUpdate = async (state: PropertyType, payload: PropertyType) => {
	const { token, page } = payload;
	return filterData(token, page, state.filters);
};

const onUpdateForm = (state: PropertyType, payload: PropertyType) => {
	const { field, value } = payload;
	// if (field.includes('custom_fields')) {
	// 	const fieldOptions = field.split('|');
	// 	const id = fieldOptions[1];
	// 	const option = fieldOptions[2];
	// 	const currentCustomFields = [...state.campaignForm.custom_fields];
	// 	const updateFieldIndex = findIndex(state.campaignForm.custom_fields, ['id', id]);
	// 	currentCustomFields[updateFieldIndex][option] = value;
	// 	const newForm = { ...state.campaignForm, custom_fields: currentCustomFields };
	// 	const errors = validateForm(newForm);
	// 	const fieldError = errors ? errors[id as CampaignFormKey] : null;
	// 	return { campaignForm: newForm, formErrors: { ...state.formErrors, [id]: fieldError } };
	// }
	const newForm = { ...state.campaignForm, [field]: value };
	const errors = validateForm(newForm);
	const fieldError = errors ? errors[field as CampaignFormKey] : null;

	return {
		campaignForm: newForm,
		formErrors: { ...state.formErrors, [field]: fieldError },
	};
};

const formReset = () => {
	return {
		campaignForm: {
			status: [],
			activePartners: [],
			partners: [],
			from_date: '',
			to_date: '',
			games: [],
			custom_fields: [],
			free_spin_total_value: '',
			free_spin_bet_value: '',
			money_drop_currency: [],
			from_spin_expiry: '',
			number_of_prizes: ['0'],
			prize_value: ['0'],
			all_games: false,
			all_users: false,
			thirdparty_campaign_id: '',
			device: [],
			provider_id: [],
			allow_api_award: false,
			auto_award_on_launch: false,
			formErrors: {},
			globalSuccess: '',
		},
		activePartners: [],
	};
};

const onCampaignAdd = async (state: PropertyType, payload: PropertyType) => {
	const { token, campaignForm } = payload;
	const formErrors = validateForm(campaignForm);
	// const games = [...state.games];
	let responesMsg = '';
	if (formErrors) {
		return { formErrors };
	} else {
		const { campaign, message } = await addMoneyDrop({ token, campaignForm });
		responesMsg = message;
		// games.unshift(game);

		return {
			globalSuccess: responesMsg,
			campaign,
		};
	}
};

const onUpdateCampaignPartnersForm = (state: PropertyType, payload: PropertyType) => {
	const { activePartners } = payload;

	return {
		...state,
		campaignForm: {
			...state.campaignForm,
			partners: activePartners, // za API
		},
		activePartners, // za UI (TreeSelect.selected)
	};
};

const filtersInit = async (payload: PropertyType) => {
	const { token, filters } = payload;
	const resp = await getFilterOptions({ token, filters });

	return { ...resp.data };
};

export const actions: ActionsType = {
	LOADING: (state, payload) => ({ campainsLoading: payload }),
	CAMPAIGNS_INIT: (state, payload) => onRequest(() => campaignsInit(payload), true),
	PARTNERS_INIT: (state, payload) => partnersInit(payload),
	GAMES_INIT: (state, payload) => gamesInit(payload),
	STATUSES_INIT: (state, payload) => onRequest(() => statusesInit(payload), true),
	PAGE_UPDATE: (state, payload) => onRequest(() => onPageUpdate(state, payload), true),
	UPDATE_COLUMNS: (state, payload) => ({ columns: payload }),
	UPDATE_ROWS: (state, payload) => ({ rows: payload }),
	FILTER: (state, payload) => onFilter(state, payload),
	UPDATE_FILTERS: (state, payload) => ({ filters: payload }),
	GLOBAL_ERROR: (state, payload) => ({ globalErrors: payload }),
	GLOBAL_SUCCESS: (state, payload) => ({ globalSuccess: payload }),
	MESSAGE_INVALIDATE: () => ({ globalErrors: [], globalSuccess: '', campainsLoading: false }),
	FORM: (state, payload) => onUpdateForm(state, payload),
	FORM_RESET: () => formReset(),
	PARTNERS_UPDATE: (state, payload) => ({ activePartners: payload }),
	CAMPAIGN_ADD: (state, payload) => onCampaignAdd(state, payload),
	FORM_CAMPAIGN_PARTNERS: (state, payload) => onUpdateCampaignPartnersForm(state, payload),
	FILTERS_INIT: (state, payload) => onRequest(() => filtersInit(payload)),
	CURRENCY: (payload) => ({ activeCurrency: payload }),
};
